// extracted by mini-css-extract-plugin
module.exports = {"VisuallyHidden":"VisuallyHidden-module--VisuallyHidden--2V6g1"};